
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Upload = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect x="-0.1" y="-0.2" width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M20.6,11.6v4.2a2.2,2.2,0,0,1-2.2,2.3H4.4V11.6H2.9v8H18.4a3.7,3.7,0,0,0,3.7-3.8V11.6Z"></path>
            <polygon points="11.8 4.8 11.8 14.7 13.3 14.7 13.3 4.8 16.8 8.3 17.8 7.2 12.5 1.9 7.2 7.2 8.2 8.3 11.8 4.8"></polygon>
          </g>
        </g>
      </g>
    </IconBase>);
};

Upload.defaultProps = {
  title: 'Upload',
};

export default Upload;
